import NotificationColor from './NotificationColour.svg';
import NotificationDark from './NotificationDark.svg';
import NotificationLight from './NotificationLight.svg';
export const notification = {
    color: NotificationColor,
    dark: NotificationDark,
    light: NotificationLight
};
//# sourceMappingURL=index.js.map